// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"650dc937","455":"817c5fe6"}[chunkId] + ".chunk.js";
};